<template>
  <confirm-dialog
    v-show="isShow"
    :data="dialogData"
    name="pdfPickerModal"
    @confirm="handleConfirm"
  >
    <div class="pdf-picker-modal box">
      <div
        class="upload-box col d-flex flex-column align-items-center justify-content-center"
      >
        <input
          type="file"
          accept="application/pdf"
          class="input-file file"
          @change="fileChange($event.target.files)"
        />
        <span v-if="!hasFile">
          <img
            :src="'/static/icons/add-file.svg'"
            class="mb-3"
            width="26"
            height="26"
          />
        </span>
        <span v-if="!hasFile">
          เพิ่มไฟล์ PDF ที่นี่
        </span>
        <span v-if="hasFile">
          <img
            :src="'/static/icons/correct-circle.svg'"
            class="mb-3"
            width="26"
            height="26"
          />
        </span>
        <span v-if="hasFile">
          {{ pdfName }}
        </span>
      </div>
      <div class="remake">ขนาดไฟล์สูงสุดคือ 1 MB</div>
    </div>
  </confirm-dialog>
</template>

<script>
import { UPLOAD } from "@/config/constant";
import { isEmpty, isNil } from "ramda";

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    fileName: {
      type: String,
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: null,
      fileChanged: false,
      upload: UPLOAD
    };
  },
  computed: {
    dialogData() {
      const buttonSubmit = this.isLoading ? "กำลังดำเนินการ" : "เลือก";

      return {
        title: this.title,
        buttonCancel: "ยกเลิก",
        buttonSubmit,
        disableSubmit: this.isLoading,
        disableCancel: this.isLoading
      };
    },
    hasFile() {
      return !!((this.file || !isNil(this.fileName)));
    },
    pdfName() {
      return (!this.file && !isNil(this.fileName)) ? this.fileName : this.file.name;
    }
  },
  watch: {
    isShow(value) {
      if (!value) {
        this.file = null;
      }
    }
  },
  methods: {
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.$emit("cancel");
        this.removeFile();
        return;
      }

      if (!this.fileChanged) {
        const oldFile = this.fileName && !this.file
          ? 'HAVEOLDFILE'
          : null

        this.$emit("fileNotChanged", oldFile);
        return;
      }

      this.$emit("confirm", this.file);
      this.fileChanged = false;
    },
    removeFile() {
      this.file = null;
    },
    fileChange(files) {
      const [file] = files;

      if (files.length === 0 && !isEmpty(this.file)) {
        return false;
      }

      if (file.size / 1024 / 1024 > UPLOAD.MAX_FILE_SIZE_MB) {
        this.$message.error(
          `${this.$t("feature.upload.exceed_max_file_size")} ${
            UPLOAD.MAX_FILE_SIZE_MB
          } MB`
        );

        return false;
      }

      this.file = file;
      this.fileChanged = true;

      return true;
    }
  }
};
</script>

<style lang="scss">
.pdf-picker-modal {
  .upload-box {
    position: relative;
    border: 2px dashed #d8d6d9;

    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #8c8786;
    object-fit: thumbnail;

    margin: 0 auto;
    width: 300px;
    height: 200px;

    > canvas {
      position: relative;
      z-index: 1;
    }
  }
  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0;
    width: 360px;
    height: 154px;
    position: absolute;
    cursor: pointer;
    z-index: 99;
  }
  .btn-remove {
    position: absolute;
    width: 25px;
    height: 25px;
    top: -10px;
    right: -10px;
    z-index: 3;
  }
  .show-file {
    width: 360px;
    height: 154px;
  }
  .remake {
    font-size: 11px;
    font-weight: normal;
    line-height: 1.64;
    letter-spacing: -0.1px;
    color: #8c8786;
    margin-top: 16px;
    text-align: center;
  }

  .placeholder {
    z-index: 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    user-select: none;
  }
}
</style>
